import { martinTilesBaseUrl } from '@/config/env'
import type Basemap from '@/models/interfaces/map/Basemap'

export const DEFAULT_BASEMAP: Basemap = {
  id: 'openstreetmap',
  name: 'OpenStreetMap',
  style: 'https://api.maptiler.com/maps/streets-v2/style.json',
}

/** Fonds proposés dans le sélecteur quand internet est joignable. */
export const ONLINE_BASEMAPS: Basemap[] = [
  DEFAULT_BASEMAP,
  {
    id: 'satellite',
    name: 'Satellite',
    style: 'https://api.maptiler.com/maps/satellite/style.json',
  },
]

/**
 * Source Martin du fond hors ligne (fichier PMTiles du Cameroun, voir docs/CARTE_HORS_LIGNE.md).
 * Non renseignée : pas de fond hors ligne, la carte garde le comportement en ligne seul.
 */
export const offlineBasemapSource: string = (
  (import.meta.env.VITE_OFFLINE_BASEMAP_SOURCE as string | undefined) ?? ''
).trim()

export const isOfflineBasemapAvailable: boolean = Boolean(offlineBasemapSource && martinTilesBaseUrl)

export const OFFLINE_BASEMAP_ID = 'offline'

/** Son style n'est pas une URL : il est construit localement (voir OfflineBasemapStyle). */
export const OFFLINE_BASEMAP: Basemap = {
  id: OFFLINE_BASEMAP_ID,
  name: 'Hors ligne',
  style: '',
}

export function isOfflineBasemap(basemap: Basemap): boolean {
  return basemap.id === OFFLINE_BASEMAP_ID
}

/**
 * Fond à afficher : celui demandé tant qu'internet répond, le fond local sinon (s'il est
 * configuré ; à défaut on garde le fond demandé, comme avant).
 */
export function resolveEffectiveBasemap(requested: Basemap | null | undefined, isOnline: boolean): Basemap {
  if (!isOnline && isOfflineBasemapAvailable) return OFFLINE_BASEMAP
  return requested ?? DEFAULT_BASEMAP
}
